<template>
  <div id="overview">
    <div class="box clearfix">
      <div class="left">
        <div class="box1 h-292">
          <p class="title"><span class="blue-border"></span> 欢迎登录</p>
          <div class="clearfix">
            <div class="img f-l">
              <!-- <img :src="userData.avatar" class="avatar"> -->
              <img :src="userData.avatar" class="avatar">
              <p class="username">{{userData.displayName}}</p>
              </p>
            </div>
            <div class="user-details f-l">
              <p :title='userData.groupName'><img src="@/assets/image/overview/icon1.png">组织：<span
                  class="blue">{{userData.groupName}}</span></p>
              <p :title='userData.roleNameSet'><img src="@/assets/image/overview/icon2.png">角色：<span
                  class="blue">{{userData.roleNameSet}}</span></p>
              <p><img src="@/assets/image/overview/icon3.png">公众号：<span
                  class="green">{{userData.wechatId==null||userData.wechatId==''?'未绑定':'已绑定'}}</span></p>
            </div>
            <div class="user-details f-l w-45">
              <p :title="'上次登录：'+changeTime(loginData.lastLoginTime)+' '+loginData.lastLoginLocation"><img
                  src="@/assets/image/overview/icon4.png">上次登录：<span
                  class="blue">{{changeTime2(loginData.lastLoginTime,1)}} {{loginData.lastLoginLocation}}</span></p>
              <p :title="'本次登录：'+changeTime(loginData.loginTime)+' '+loginData.loginLocation"><img
                  src="@/assets/image/overview/icon5.png">本次登录：<span class="blue">{{changeTime2(loginData.loginTime,1)}}
                  {{loginData.loginLocation}}</span></p>
              <p><img src="@/assets/image/overview/icon6.png" style="left: 4px;">本月在线时长：<span
                  class="green">{{getTime(loginData.duration)}}</span></p>
            </div>
          </div>
        </div>
        <!-- <div class="box1 clearfix b-t">
                    <div class="box2 f-l f-14">
                        <p class="title"><img :src="qy" class="icon"> 企业概览</p>
                        <div class="clearfix">
                            <div class="f-l t-c w-50 ">
                                总数<span class="number">{{companyOverview.total}}</span>
                                <img :src="jt1" class="jt1" v-show="companyOverview.total>companyOverview.lastTotal">
                                <img :src="jt2" class="jt2" v-show="companyOverview.total<companyOverview.lastTotal">
                            </div>
                            <div class="f-r t-c w-50">
                                在线<span class="number">{{companyOverview.online}}</span>
                                <img :src="jt1" class="jt1" v-show="companyOverview.online>companyOverview.lastOnline">
                                <img :src="jt2" class="jt2" v-show="companyOverview.online<companyOverview.lastOnline">
                            </div>
                        </div>
                    </div>
                    <div class="box2 f-r f-14">
                        <p class="title"><img :src="yh" class="icon"> 用户概览</p>
                        <div class="clearfix">
                            <div class="f-l t-c w-50 ">
                                总数<span class="number">{{userOverview.total}}</span>
                                <img :src="jt1" class="jt1" v-show="userOverview.total>userOverview.lastTotal">
                                <img :src="jt2" class="jt2" v-show="userOverview.total<userOverview.lastTotal">
                            </div>
                            <div class="f-r t-c w-50">
                                在线<span class="number">{{userOverview.online}}</span>
                                <img :src="jt1" class="jt1" v-show="userOverview.online>userOverview.lastOnline">
                                <img :src="jt2" class="jt2" v-show="userOverview.online<userOverview.lastOnline">
                            </div>
                        </div>
                    </div>
                </div> -->
        <div class="flex-boxs">
          <div class="flex-item bg1">
            <div class="text-box">
              <div class="num">{{companyOverview.online}}/{{companyOverview.total}}
                <img :src="jt1" class="jt1" v-if="companyOverview.online>companyOverview.lastOnline">
                <img :src="jt2" class="jt2" v-if="companyOverview.online<companyOverview.lastOnline">
              </div>
              <div class="text">在线企业</div>
            </div>
          </div>
          <div class="flex-item bg2">
            <div class="text-box">
              <div class="num">{{userOverview.online}}/{{userOverview.total}}
                <img :src="jt1" class="jt1" v-if="userOverview.online>userOverview.lastOnline">
                <img :src="jt2" class="jt2" v-if="userOverview.online<userOverview.lastOnline">
              </div>
              <div class="text">在线用户</div>
            </div>
          </div>
          <div class="flex-item bg3">
            <div class="text-box">
              <div class="num">{{deviceOverview.total}}
                <img :src="jt1" class="jt1" v-if="deviceOverview.total>deviceOverview.lastTotal">
                <img :src="jt2" class="jt2" v-if="deviceOverview.total<deviceOverview.lastTotal">
              </div>
              <div class="text">设备总数</div>
            </div>
          </div>
        </div>
        <div class="box1 h-400">
          <p class="title"><span class="blue-border"></span> 企业运维</p>
          <div class="flex-box2">
            <div class="flex-item2 clearfix" @click="toCompanyConsole(item)" v-for="item,i in CompanyList" :key="i" v-if="i<6" :class="{'warn':item.state==4,'err':item.state==3}">
              <el-image :src="item.logo" fit="contain" class="el-img">
                <div slot="error" class="image-slot">
                  <!-- <i class="el-icon-picture-outline"></i> -->
                </div>
              </el-image>
              <div class="text-box2">
                <div class="c-name">{{item.name}}</div>
                <div class="online" :class="{'bluck':item.state==1}">
                  <img src="@/assets/image/overview/icon7.png" v-if="item.state==1">
                  <img src="@/assets/image/overview/icon8.png" v-if="item.state!=1">{{item.state==1?'离线':'在线'}}
                </div>
              </div>
              <img src="@/assets/image/overview/warn.png" class="warn-icon" v-if="item.state==4">
              <img src="@/assets/image/overview/err.png" class="warn-icon" v-if="item.state==3">
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="box1 h-292">
          <p class="title"><span class="blue-border"></span> 平台公告</p>
          <div class="Notice o-a h-2">
            <p v-for="(msg,m) in sysMsgList" @click='to' :title='msg.context' v-if='m<4'><span class="dian"
                v-if="msg.state==2"></span><span class="context">{{msg.context}}</span><span
                class="time">{{changeTime2(msg.createdTime,2)}}</span></p>
            <p v-if='$store.state.messageList.length==0' style="border: none;">无最新消息</p>
          </div>
        </div>
        <div class="box1 h-292">
          <p class="title"><span class="blue-border"></span> 最新消息</p>
          <div class="Notice o-a h-2">
            <p v-for="(msg,m) in msgList" @click='to' :title='msg.context' v-if='msg.state==2&&m<4'><span
                class="dian"></span><span class="context">{{msg.context}}</span><span
                class="time">{{changeTime2(msg.createdTime,2)}}</span></p>
            <p v-if='$store.state.messageList.length==0' style="border: none;">无最新消息</p>
          </div>
        </div>
        <div class="box1 h-292">
          <p class="title"><span class="blue-border"></span> 报警概览</p>
          <div class="chart-box clearfix">
            <div class="chart f-l" ref="chart"></div>
            <div class="chart-right f-r">
              <div class="value-item">
                <img src="@/assets/image/overview/q1.png" class="quan">
                <span>未确认</span>
                <span class="chart-num color1">{{warnData.count1}}</span>
              </div>
              <div class="value-item">
                <img src="@/assets/image/overview/q2.png" class="quan">
                <span>已确认</span>
                <span class="chart-num color2">{{warnData.count2}}</span>
              </div>
              <div class="value-item">
                <img src="@/assets/image/overview/q3.png" class="quan">
                <span>已恢复</span>
                <span class="chart-num color3">{{warnData.count3}}</span>
              </div>

            </div>
          </div>
        </div>
        <!-- <div class="box3">
                    <p class="title"><img :src="xx" class="icon"> 最新消息</p>
                    <div class="Notice o-a h-2">
                        <p v-for="(msg,m) in $store.state.messageList" @click='to' :title='msg.context'  v-if='msg.state==2&&m<10'><span class="dian"></span>{{msg.context}}</p>
                        <p v-if='$store.state.messageList.length==0'>无最新消息</p>
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        warnData: {
          count1: 0,
          count2: 0,
          count3: 0
        },
        mqttUrlList:[],
        sysMsgList: [],
        userData: {}, //用户信息
        loginData: {}, //用户登录信息
        // avatar:require('@/assets/image/company/qyzu.png'),
        jt1: require('@/assets/image/overview/jt1.png'),
        jt2: require('@/assets/image/overview/jt2.png'),
        c1: require('@/assets/image/overview/c1.png'),
        c2: require('@/assets/image/overview/c2.png'),
        jt3: require('@/assets/image/index/jt3.png'),
        jt4: require('@/assets/image/index/jt4.png'),
        hy: require('@/assets/image/index/hy' + this.cssType + '.png'),
        qy: require('@/assets/image/index/qy' + this.cssType + '.png'),
        yh: require('@/assets/image/index/yh' + this.cssType + '.png'),
        sb: require('@/assets/image/index/sb' + this.cssType + '.png'),
        gg: require('@/assets/image/index/gg' + this.cssType + '.png'),
        xx: require('@/assets/image/index/xx' + this.cssType + '.png'),
        //
        userOverview: {}, //用户概览对象
        companyOverview: {}, //企业概览对象
        deviceOverview: {}, //设备概览对象
        client: {},
        oldEnergy: null, //上一次的能耗
        energy: 0,
        noticeList: [],
        lhl: null,
        gzl: null,
        url: '',
        datalist: [], //运维中心配置、
        list: [],
        companyList: [], //企业列表
        showList: [],
        CompanyList:[], //展示列表
      }
    },
    created() {
      this.$store.state.activeIndex = '/Overviews'
      this.oldEnergy = localStorage.getItem('oldEnergy')
      this.getUserData()
      this.getLoginTime()
      this.getCompanyOverview()
      this.getUser()
      this.getDevice()
      this.getWarn()
      this.getSysMsg()
    },
    computed: {
      msgList() {
        return this.$store.state.messageList.filter(i => i.state == 2)
      }
    },
    methods: {

      // 跳转运维中心
      async toCompanyConsole(item) {
        if (!this.$store.state.functionList.includes('companyServiceView') || item.activeState == 2) {
          return
        }
        if (this.isSort) {
          this.isSort = false
          return
        }
        if (item.createdTime) {
          this.$store.state.companyCreatedTime = item.createdTime
        }
        let company = this.companyList.filter(i => i.id == item.id)[0]
        // this.get('/Company/get',{id:item.id}).then(res=>{
        //   if(res.success){
        //     company = res.result
        //   }
        // })
        await this.get('/UserConfig/get',{name:'mute'}).then((res)=>{
            if(res.success){
              this.$store.state.userConfig.mute=res.result.value?Number(res.result.value):0
              localStorage.setItem('mute',this.$store.state.userConfig.mute)
            }
        })
        let energyShow = false,ScreenPage=false
        this.$store.state.companyIndexPreviewUrl="/CompanyConsole/IndexEditShow"
        await this.get('/Screen/getHomepage',{companyId:item.id,type:1}).then(res=>{
          if(res.success){
            if(res.success&&res.result.id){
              ScreenPage = true
              this.$store.state.companyIndexPreviewUrl = "/CompanyConsole/indexPreview?type=1&id="+res.result.id
            }
          }
        })
        if(company&&company.module){
          if(company.module.indexOf('Energy')!=-1){
            energyShow = true
          }
        }
        let homepage = localStorage.getItem('homepage')
        // 没有能源管理方案,或者有应用大屏时修改配置路径
        if(homepage=="/Energy/index"&&energyShow){
          this.$store.state.userConfig.homepage="/Energy/index"
        }else{
          homepage = this.$store.state.companyIndexPreviewUrl
        }
        // 更新vuex路径
        if (homepage != this.$store.state.userConfig.homepage) {
          this.$store.state.userConfig.homepage = homepage
        }

        this.$store.state.energyShow = energyShow
        this.$store.state.companyCode = company.code
        let state = JSON.stringify(this.$store.state)
        localStorage.setItem("store", state)
        localStorage.setItem('companyId', item.id)
        sessionStorage.setItem("store", state)
        sessionStorage.setItem('companyId', item.id)
        clearInterval(this.timeInterval)
        console.log(item)
        this.windowOpen(this.$store.state.userConfig.homepage, item.id,null,item.title)
        // if(this.$store.state.userConfig.homepage =='/Energy/index'){
        //   this.windowOpen('/Energy/index',item.id)
        // }else{
        // }
      },

      // 获取运维中心配置
      getDataList() {
        this.get('/UserConfig/get', {
          name: 'overview'
        }).then((res) => {
          if (res.success) {
            this.datalist = res.result.value == null || res.result.value == 'null' || res.result
              .value == '' ? [] :
              JSON.parse(res.result.value)
            for (let item of this.datalist) {
              this.list.push(item.id)
            }
            this.getCompany()
          } else {
            this.$message({
              message: `获取列表失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },

      // 获取企业
      getCompany() {
        this.get('/Company/getList').then((res) => {
          if (res.success) {
            this.companyList = this.clone(res.result)
            for (let company of res.result) {
              this.showList.push(company.id)
              if (!this.list.includes(company.id)) {
                let obj = {
                  name: company.shortName,
                  code: company.code,
                  id: company.id,
                  state: 1,
                  status:1,
                  createdTime: company.createdTime,
                  waringMsg: [],
                  data: [],
                  activeState: company.state,
                  logo: company.logo,
                  title:company.title
                }
                this.datalist.push(obj)
              } else {
                for (let item of this.datalist) {
                  if (company.id == item.id) {
                    item.name = company.shortName,
                      item.code = company.code,
                      item.activeState = company.state,
                      item.id = company.id,
                      item.title = company.title,
                      item.state = 1,
                      item.status=1,
                      item.logo = company.logo
                  }
                }
              }
            }
          }
        }).then(() => {
          // console.log(this.datalist)
          this.replaceCompany()
        })
      },
      // 删除不存在的企业
      replaceCompany() {
        let obj = []
        for (let i in this.datalist) {
          if (this.showList.includes(this.datalist[i].id)) {
            obj.push(this.datalist[i])
          }
          if (i == this.datalist.length - 1) {
            this.CompanyList = obj
            this.mqttState()
          }
        }
      },
      mqttState() {
      	for (let company of this.CompanyList) {
          let url = 'sys/company/' + company.id + '/status/push'
          this.mqttUrlList.push(url)
      		this.client.subscribe(url, {
      			qos: 1
      		}, (error) => {
      			if (!error) {
      				// console.log('订阅设备属性主题成功')
      			} else {
      				// console.log('订阅设备属性主题失败')
      			}
      		})
      	}
      },
      getSysMsg() {
        this.get('/Message/query', {
          pageNumber: 1,
          length: 10,
          type: 6
        }).then((res) => {
          if (res.success) {
            this.sysMsgList = res.result.data
          } else {
            this.$message({
              message: `获取平台公告失败：${res.message}`,
              type: 'warning'
            });
          }

        })
      },
      getWarn() {
        this.get('/DeviceAlarm/groupAlarmByCategory').then(res => {
          if (res.success) {
            if(res.result){
              for (let c of res.result) {
                if (c.category == 1) {
                  this.warnData.count1 = c.count
                } else if (c.category == 2) {
                  this.warnData.count2 = c.count
                } else if (c.category == 3) {
                  this.warnData.count3 = c.count
                }
              }
            }
          } else {
            this.$message({
              message: `获取报警概览失败：${res.message}`,
              type: 'warning'
            });
          }
          this.setCharts()
        })
      },
      setCharts() {
        let t = this,count = this.warnData.count1 + this.warnData.count2 + this.warnData.count3;
        let color1 = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: "#FE8AD1"
        }, {
          offset: 1,
          color: "#F84886"
        }], false);
        let color2 = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: "#FAD06A"
        }, {
          offset: 1,
          color: "#FF8657"
        }], false);
        let color3 = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
          offset: 0,
          color: "#0FAEFF"
        }, {
          offset: 1,
          color: "#39DBFF"
        }], false);
        let option = {
          color: [color1, color2, color3],
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}'
          },
          legend: {
            show: false,
          },
          title: [{ // 第一个圆环标题
            text: '报警总数', // 主标题
            textStyle: { // 主标题样式
              color: '#333',
              fontSize: 16,
              fontFamily: 'Microsoft YaHei'
            },
            left: '46%', // 定位到适合的位置
            top: '35%', // 定位到适合的位置
            subtext: count, // 副标题
            subtextStyle: { // 副标题样式
              color: '#333',
              fontSize: 36,
              fontFamily: 'agencyb',
            },
            textAlign: 'center' // 主、副标题水平居中显示
          }, ],
          series: [{
              name: '报警概览',
              type: 'pie',
              radius: ['50%', '90%'],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              hoverAnimation: false,
              z: 9,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                scale: false,
                label: {
                  show: false,
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              itemStyle: {
                normal: {
                  borderWidth: 2,
                  borderColor: "#ffffff"
                }
              },
              labelLine: {
                show: false
              },
              startAngle: 165,
              data: [{
                  value: t.warnData.count1,
                  name: '未确认',
                },
                {
                  value: t.warnData.count2,
                  name: '已确认'
                },
                {
                  value: t.warnData.count3,
                  name: '已恢复'
                },
              ]
            },
            // 内圈阴影
            {
              name: '',
              type: 'pie',
              radius: ['50%', '60%'],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              hoverAnimation: false,
              z: 10,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                scale: false
              },
              itemStyle: {
                normal: {
                  borderWidth: 2,
                  borderColor: "#ffffff"
                }
              },
              labelLine: {
                show: false
              },
              startAngle: 165,
              data: [{
                  value: t.warnData.count1,
                  name: '未确认',
                  tooltip: {
                    show: false
                  },
                  itemStyle: {
                    color: "#000000",
                    opacity: 0.3
                  }
                },
                {
                  value: t.warnData.count2,
                  name: '已确认',
                  tooltip: {
                    show: false
                  },
                  itemStyle: {
                    color: "#000000",
                    opacity: 0.3
                  }
                },
                {
                  value: t.warnData.count3,
                  name: '已恢复',
                  tooltip: {
                    show: false
                  },
                  itemStyle: {
                    color: "#000000",
                    opacity: 0.3
                  }
                },
              ]
            },
          ]
        };
        var dom = this.$refs.chart
        if (dom) {
          var chartSet = this.$echarts.init(dom, '', {
            width: 186, //设置宽高
            height: 186
          })
          chartSet.setOption(option)
        }
      },
      changeTime2(time,type) {
        if (!time) {
          return ''
        }
        let now = new Date(Number(time))
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        let hour = now.getHours(); //返回日期中的小时数（0到23）
        let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if (hour < 10) {
          hour = "0" + hour
        }
        if (minute < 10) {
          minute = "0" + minute
        }
        if(type==1){
          return `${month}/${date} ${hour}:${minute}`
        }else{
          return `${month}-${date} ${hour}:${minute}`
        }

      },
      // 获取用户信息
      getUserData() {
        this.userData = this.$store.state.userData
        if (!this.userData.id) {
          this.get('/UserProfile/get').then((res) => {
            if (res.success) {
              this.userData = res.result;
              this.$store.state.userData = this.clone(this.userData);
            } else {
              this.$message({
                message: `获取用户信息失败：${res.message}`,
                type: 'warning'
              });
            }
          }).then(() => {
            if (this.$store.state.client) {
              this.client = this.$store.state.client
              this.mqttMSG()
            } else {
              this.setMqtt()
            }
            this.getDataList()
          })
        } else {
          if (this.$store.state.client) {
            this.client = this.$store.state.client
            this.mqttMSG()
          } else {
            this.setMqtt()
          }
          this.getDataList()
        }
      },
      // 获取登录信息
      getLoginTime() {
        this.get('/UserProfile/getLoginInfo').then((res) => {
          if (res.success) {
            this.loginData = res.result
          } else {
            this.$message({
              message: `获取用户登录信息失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 获取企业概览
      getCompanyOverview() {
        this.get('/Company/getOverview').then((res) => {
          if (res.success) {
            this.companyOverview = res.result
          } else {
            this.$message({
              message: `获取企业概览数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 获取用户概览
      getUser() {
        this.get('/User/getOverview').then((res) => {
          if (res.success) {
            this.userOverview = res.result
            // console.log(res.result)
          } else {
            this.$message({
              message: `获取用户概览数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 获取设备概览
      getDevice() {
        this.get('/Device/getOverview').then((res) => {
          if (res.success) {
            this.deviceOverview = res.result
            // console.log(res.result)
          } else {
            this.$message({
              message: `获取设备概览数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 跳转
      to() {
        this.$router.push({
          path: '/Message'
        })
      },
      // 秒数转时长
      getTime(s) {
        var time = s
        if (null != time && "" != time) {
          if (time > 60 && time < 60 * 60) {
            time = parseInt(time / 60.0) + "分"
          } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分"
          } else if (time >= 60 * 60 * 24) {
            time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
              parseInt(time / 3600.0 / 24)) * 24) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分"
          } else {
            time = parseInt(time) + "秒";
          }
        }
        return time;
        // console.log(time)
      },
      // mqtt 链接
      setMqtt() {
        let options = {
          clientId: this.$store.state.userData.code + "_overviews",
          connectTimeout: 600000,
          clean: true
        }
        this.$store.state.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
        this.client = this.$store.state.client
        this.mqttMSG()
      },
      // 订阅主题
      mqttMSG() {
        this.url = 'sys/user/' + this.$store.state.userData.code + '/overview/push'
        // console.log(url)
        this.client.subscribe(this.url, {
          qos: 1
        }, (error) => {})
        this.client.on('message', (topic, message) => {
          if (topic == this.url) {
            let obj = message.toString()
            obj = JSON.parse(obj)
            this.oldEnergy = this.energy
            localStorage.setItem('oldEnergy', this.oldEnergy)
            this.energy = obj.SYS_ENERGY
            // console.log(this.energy,this.oldEnergy)
            if (obj.SYS_STATUS) {
              // this.setChart(obj.SYS_STATUS,1)
            }
            if (obj.SYS_FAILURE) {
              // this.setChart(obj.SYS_FAILURE,2)
            }
            this.$forceUpdate()
          }else if (topic.indexOf('sys/company/') != -1&&topic.indexOf('status/push') != -1) {
      			let obj = message.toString()
      			if (obj) {
      				obj = JSON.parse(obj)
      				for (let company of this.CompanyList) { //循环所有企业
      					if (company.id == obj.companyId) {
      						if (!JSON.parse(obj.online)) {
      							company.state = 1
      						} else if (obj.alarm.error > 0) {
      							company.state = 3
      						} else if ((obj.alarm.infor > 0) || (obj.alarm.warn > 0)) {
      							company.state = 4
      						} else {
      							company.state = 2
      						}
      					}
      				}
      				this.$forceUpdate()
      			}
      		}
        })
      },
      // 修改echart 环形图
      setChart(data, type) {
        var dom;
        if (type == 1) {
          dom = this.$refs.lhl
        } else {
          dom = this.$refs.gzl
        }
        var option = {
          legend: {
            orient: 'vertical',
            left: 10,
            data: [], //空数组则不展示
            textStyle: {
              color: '#FFFFFF',
              borderRadius: 0,
              padding: [2, 0, 0, 8]
            },
          },
          graphic: [{ //环形图中间添加文字
            type: 'text', //通过不同top值可以设置上下显示
            left: 'center',
            top: '32%',
            cursor: 'default',
            style: {
              text: type == 1 ? '良好率' : '故障率',
              textAlign: 'center',
              fill: '#000',
              fontSize: 14,
              color: "#4d4f5c",
              fontFamily: "Microsoft YaHei",
            }
          }, {
            type: 'text',
            left: 'center',
            top: '48%',
            cursor: 'default',
            style: {
              text: data + "%",
              textAlign: 'center',
              fill: '#000',
              fontSize: 22,
              fontWeight: 'bold',
            }
          }],
          color: type == 1 ? ['#03b615', '#d4f7d7'] : ['#d9001b', '#f9e4e7'], //环形颜色 ddd 灰  d4f7d7 浅蓝 f9e4e7 浅红
          series: [{
            name: type == 1 ? '良好率' : '故障率',
            type: 'pie',
            cursor: 'default',
            radius: ['75%', '95%'], //环形图
            hoverAnimation: false, //移入放大
            labelLine: { //禁用引导线
              show: false
            },
            data: [{
                value: data,
                itemStyle: {
                  emphasis: {
                    color: type == 1 ? '#03b615' : '#d9001b'
                  }
                }
              },
              {
                value: 100 - data,
                itemStyle: {
                  emphasis: {
                    color: type == 1 ? '#d4f7d7' : '#f9e4e7'
                  }
                }
              },
            ]
          }, ]
        }
      }
    },
    beforeDestroy() {
      // console.log("退订成功")
      if (this.url != '') {
        let options = {
          onSuccess() {},
          onFailure(error) {}
        }
        this.client.unsubscribe(this.url, options)
      }

        for (let item of this.mqttUrlList) {
          let options = {
            onSuccess() {
              // console.log("退订成功")
            },
            onFailure(error) {
              // console.log("退订失败")
            }
          }
          this.client.unsubscribe(item, options)
        }
    },
  }
</script>
<style scoped>
  .chart-unit {
    font-size: 14px;
  }

  .chart-num {
    font-size: 24px;
    margin-left: 16%;
    font-family: agencyb;
  }

  .color1 {
    background: linear-gradient(180deg, #FE8AD1 0%, #F84886 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .color2 {
    background: linear-gradient(180deg, #FAD06A 0%, #FF8657 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .color3 {
    background: linear-gradient(180deg, #32D4FF 0%, #13B2FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .quan {
    width: 24px;
    height: 24px;
    margin-right: 5px;
    position: relative;
    top: 6px;
  }

  .value-item {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    font-family: Microsoft YaHei;
    color: #666666;
    line-height: 38px;
  }

  .chart {
    margin: 10px 10px 0 5%;
    width: 186px;
  }

  .chart-right {
    width: calc(95% - 196px);
    margin-top: 10px;
    padding-top: 40px;
    height: 50px;
    box-sizing: border-box;
  }

  .warn-icon {
    float: right;
    margin-right: 6%;
    margin-top: 30px;
    width: 40px;
    height: 40px;
  }

  .c-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 22px;
    color: #333333;
  }

  .text-box2 {
    margin-top: 14px;
    width: 50%;
    display: inline-block;
    float: left;
  }

  .online {
    font-size: 18px;
    color: #00CC33;
  }

  .online.bluck {
    color: #B1B1B1;
  }

  .online img {
    position: relative;
    top: 6px;
    margin-right: 6px;
  }

  .el-img {
    float: left;
    width: 64px;
    height: 64px;
    background: #FFFFFF;
    border: 1px solid #C5C5C5;
    border-radius: 10px;
    margin: 14px 14px 0 23px;
  }

  .flex-box2 {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .flex-item2 {
    width: calc(50% - 12px);
    height: 90px;
    background: linear-gradient(0deg, #F0F0F0, rgba(255, 255, 255, 0));
    border-radius: 8px;
  }

  .warn {
    background: linear-gradient(0deg, #FFE7D1, rgba(255, 255, 255, 0));
  }

  .err {
    background: linear-gradient(0deg, #FFD5D6, rgba(255, 255, 255, 0));
  }

  .flex-boxs {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 21px;
    height: 184px;
    justify-content: space-between;
    margin-bottom: 22px;
  }

  .flex-item {
    width: calc(33.33% - 19px);
    height: 184px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 8px;
    overflow: hidden;
  }

  .text-box {
    color: #fff;
    font-family: agencyb;
    text-align: left;
    padding: 60px 0 0 41px;
  }

  .num {
    font-size: 36px;
    line-height: 36px;
    margin-bottom: 14px;
  }

  .text {
    line-height: 18px;
    font-size: 18px;
  }

  .bg1 {
    background-image: url("../../assets/image/overview/bg1.png");
  }

  .bg2 {
    background-image: url("../../assets/image/overview/bg2.png");
  }

  .bg3 {
    background-image: url("../../assets/image/overview/bg3.png");
  }

  .username {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }

  .blue {
    color: #0066FF !important;
  }

  .green {
    color: #00CC33 !important;
  }

  .blue-border {
    display: inline-block;
    margin-left: 6px;
    width: 8px;
    height: 20px;
    background: #0066FF;
  }

  .title {
    font-size: 24px;
    color: #333333;
  }

  #overview {
    position: absolute;
    width: 100%;
    height: 100%;
    top: -16px;
    left: 0;
    font-family: SHR;
  }

  .box {
    padding: 22px;
    padding-right: 0;
    height: 100%;
    box-sizing: border-box;
  }

  .left {
    float: left;
    width: 69.8%;
    height: 100%;
  }

  .right {
    float: right;
    width: calc(30.2% - 20px);
    height: 100%;
  }

  .box1 {
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
    background-color: #fff;
    height: 30%;
    margin-bottom: 22px;
    font-size: 14px;
    border-radius: 8px;
  }

  .h-292 {
    height: 268px;
  }

  .h-400 {
    height: 354px;
    margin-bottom: 0;
  }

  .avatar {
    width: 134px;
    height: 134px;
    border-radius: 50%;
    margin-bottom: 6px;
  }

  .img {
    width: 25%;
    text-align: center;
    margin-top: 10px;
  }

  .user-details {
    margin-top: 25px;
    line-height: 35px;
    width: 25%;
    /* margin-left: 22px; */
  }
  .w-45{
    width: 45%;
    margin-left:5%;
  }
  .user-details p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 22px;
    color: #939393;
    padding-left: 30px;
    position: relative;
    margin-bottom: 5px;
  }

  .user-details img {
    position: absolute;
    top: 8px;
    left: 0;
  }

  .Notice {
    height: 192px;
  }

  .Notice p {
    position: relative;
    font-size: 16px;
    text-indent: 8px;
    color: #696969;
    white-space: nowrap;
    border-bottom: 1px solid #ddd;
    line-height: 50px;
    height: 50px
  }

  .context,
  .time {
    display: inline-block;
    width: 68%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .time {
    width: 28%;
    text-align: right;
    font-size: 16px;
    font-weight: 400;
    color: #ABABAB;
    font-family: SHL;
  }

  .null {
    text-align: center !important;
    margin-top: 15px;
  }

  .o-a {
    overflow: hidden;
  }

  .dian {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FF6666;
    display: inline-block;
    position: absolute;
    top: 22px;
    left: 0;
    z-index: 55;
  }

  .box2 {
    width: calc(50% - 11px);
    text-align: center;
    font-size: 50px;
    font-weight: bold;
    background-color: #fff;
    height: 100%;
    padding: 22px;
    box-sizing: border-box;
  }

  .f-14 {
    font-size: 14px;
    font-weight: 500;
  }

  .b-t {
    background-color: transparent;
    padding: 0;
  }

  .box3 {
    height: calc(60% + 23px);
    background-color: #fff;
    padding: 22px;
    box-sizing: border-box;
  }

  .t-c {
    text-align: center;
  }

  .w-50 {
    width: 50%;
    color: #7f7f7f;
  }

  .box2 .w-50 {
    margin-top: 48px;
  }

  .number {
    font-size: 30px;
    font-weight: bold;
    margin-left: 14px;
    color: #2c3e50;
  }

  .jt1 {
    width: 22px;
    position: relative;
    top: -10px;
  }

  .jt2 {
    width: 22px;
    position: relative;
    bottom: -10px;
  }

  .m-t-48 {
    margin-top: 48px;
  }

  .w-128 {
    width: 128px;
    height: 128px;
  }

  .flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .icon {
    width: 22px;
    position: relative;
    top: 3px;
  }

  .w-50-11 {
    width: calc(50% - 11px);
  }

  .w-128>div {
    width: 222px;
    cursor: default !important;
  }

  canvas:hover {
    cursor: default !important;
  }

  .w-12>div>canvas:hover {
    cursor: default !important;
  }

  div>canvas:hover {
    cursor: default !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/overviews/overviews.vue